import { Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../../services/auth/auth.service';
import { EsignService } from '../../services/esign-service/esign.service';
import { StorageKeys } from '../../shared/enums/storage.enum';
import { StorageService } from '../../services/storage/storage.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { EsignOverlayService } from '../../services/esign-overlay/esign-overlay.service';

@Component({
  selector: 'app-esign-document-list',
  standalone: false,
  templateUrl: './esign-document-list.component.html',
  styleUrl: './esign-document-list.component.scss'
})
export class EsignDocumentListComponent {

  faEye = faEye;

  userDetails: any;
  isLoading: boolean = false;
  user: any;
  selectedDocument: any = null;
  selectedDocumentUrl: SafeResourceUrl | null = null;
  logs: any;
  totalCount: number = 0;
  page: number = 0;
  loadingDocId: string | null = null;
  documentModalRef?: NgbModalRef;
  @ViewChild('documentModal') documentModalTpl!: TemplateRef<any>;
  loadRecords: boolean = false;
  historyErrorMessage: string = '';

  constructor(
    private readonly authService: AuthService,
    private readonly eSignService: EsignService,
    private readonly storageService: StorageService,
    private readonly router: Router,
    private readonly sanitizer: DomSanitizer,
    private readonly modalService: NgbModal,
    private readonly route: ActivatedRoute,
    private readonly location: Location,
    private readonly esignOverlayService: EsignOverlayService,
  ) {
    this.user = this.storageService.getDataFromLocalStorage(StorageKeys.USER_EMAIL);
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['token']) {
        try {
          const decoded = JSON.parse(atob(params['token']));
          this.storageService.setDataToLocalStorage(StorageKeys.ACCESS_TOKEN, decoded.token);
        } catch (e) {
          console.error('Invalid token received.');
        }
      }
      this.getSelfDetails();
      this.location.replaceState(this.router.url?.split('?')[0]);
    });
    this.getLogs(this.page);
    this.getLogsCount();
  }

  /** Delegates to the shared overlay service */
  openUploadOverlay(): void {
    this.esignOverlayService.open();
  }

  openDocumentModal(doc: any) {
    this.loadingDocId = doc?._id;
    this.eSignService.getDocument(doc?._id).subscribe({
      next: (res: any) => {
        const docUrl = res?.data;
        if (!docUrl) {
          this.loadingDocId = null;
          return;
        }
        this.selectedDocument = doc;
        this.selectedDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(docUrl);
        this.documentModalRef = this.modalService.open(this.documentModalTpl, {
          backdrop: 'static',
          size: 'xl',
          centered: true,
          scrollable: true
        });
        this.documentModalRef.result.catch(() => {
          this.loadingDocId = null;
          this.selectedDocument = null;
          this.selectedDocumentUrl = null;
        });
      },
      error: (error: any) => {
        this.loadingDocId = null;
        console.error('Failed to load document.', error);
      }
    });
  }

  closeDocumentModal() {
    this.loadingDocId = null;
    if (this.documentModalRef) {
      this.documentModalRef.close();
      this.documentModalRef = undefined;
    }
    this.selectedDocument = null;
    this.selectedDocumentUrl = null;
  }

  getSelfDetails(): void {
    this.authService.getSelfDetails().subscribe({
      next: (res) => {
        if (res?.data) {
          this.storageService.setDataToLocalStorage(StorageKeys.SELF_DETAILS, res.data);
          this.authService.setUser(res.data);
        }
      },
      error: (err) => {
        console.error('Failed to fetch self details:', err);
      }
    });
  }

  onPageChange(event: any): void {
    this.page = event.page;
    this.getLogs(this.page);
  }

  getLogs(page: number = 0) {
    this.loadRecords = true;
    this.historyErrorMessage = '';
    this.eSignService.getLogs(page).subscribe({
      next: (res: any) => {
        this.logs = res?.data;
        this.loadRecords = false;
      },
      error: (error: any) => {
        this.loadRecords = false;
        this.historyErrorMessage = error?.error?.error?.message || 'Failed to fetch logs';
      }
    });
  }

  getLogsCount() {
    this.eSignService.getLogsCount().subscribe({
      next: (res: any) => {
        this.totalCount = res?.data || 0;
      },
      error: (error: any) => {
        console.error('Failed to fetch transaction history count:', error);
      }
    });
  }
}
